import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  @Input() title!: string;
  @Input() question!: string;
  @Input() items!: any[];
  @Input() active_item!: string;
}
